import {Selector, State} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {IResponse} from '@interfaces/response';
import {tap} from 'rxjs/operators';
import {ReportGroupsTabStateModel} from '@store/report/groups/groups.model';
import {GroupService} from '@services/group/group.service';
import {IGroup} from '@interfaces/group';
import {NgxsDataRepository} from '@angular-ru/ngxs/repositories';
import {Payload, StateRepository} from '@angular-ru/ngxs/decorators';
import {DataActionWithoutSubscription} from '@shared/functions';

@StateRepository()
@State<ReportGroupsTabStateModel>({
    name: 'reportGroupTab',
    defaults: {
        groups: [],
        loader: false,
        currentPage: 1,
        itemsPerPage: 6,
        search: '',
        totalGroups: 0,
    }
})

@Injectable()
export class ReportGroupTabState extends NgxsDataRepository<ReportGroupsTabStateModel> {
    constructor(private groupService: GroupService) {
        super();
    }

    @Selector([ReportGroupTabState])
    static getSearch(state: ReportGroupsTabStateModel): string {
        return state.search;
    }

    @DataActionWithoutSubscription({cancelUncompleted: true})
    fetchGroups(): Observable<IResponse<IGroup>> {
        const limit = this.ctx.getState().itemsPerPage;
        const skip = limit * (this.ctx.getState().currentPage - 1);
        const search = this.ctx.getState().search;

        this.ctx.patchState({loader: true});
        return this.groupService.getGroups({limit, search, skip})
            .pipe(
                tap((data) => {
                    const state = this.ctx.getState();
                    this.ctx.setState({...state, groups: data.rows, totalGroups: data.total, loader: false});
                })
            );
    }

    @DataActionWithoutSubscription()
    searchGroups(@Payload('[Report groups] search groups') search: string): void {
        this.ctx.patchState({search, currentPage: 1});
    }

    @DataActionWithoutSubscription()
    getGroupsByPage(@Payload('[Report groups] get groups by page') page: number): Observable<any> {
        this.ctx.patchState({currentPage: page});
        return this.fetchGroups();
    }
}
